import Model, { attr } from '@ember-data/model'
import { Type } from '@warp-drive/core-types/symbols'
import type StringTransform from 'teacher-ui-client/transforms/string'
import type NumberTransform from 'teacher-ui-client/transforms/number'
import type BooleanTransform from 'teacher-ui-client/transforms/boolean'

/**
 * Represents a student to be imported/updated via csv during school rollover.
 * Returned by gravity when a csv is valid/invalid.
 */
export default class StudentImportValidation extends Model {
  @attr<StringTransform>('string') declare firstName: string

  @attr<StringTransform>('string') declare lastName: string

  @attr<NumberTransform>('number') declare gradePosition: number

  @attr<StringTransform>('string') declare externalId: string

  @attr<StringTransform>('string') declare studentId: string

  @attr<NumberTransform>('number') declare csvRow: number

  @attr<StringTransform>('string') declare teacherEmail: string

  @attr<StringTransform>('string') declare schoolClassName: string

  // does the candidate student (firstName+lastName) match another student in the csv?
  @attr<BooleanTransform>('boolean') declare duplicateSource: boolean

  // does the candidate student (firstName+lastName) match an existing student in the backend?
  @attr<BooleanTransform>('boolean') declare duplicateDestination: boolean

  // is the candidate student name being updated accidentally ?
  @attr<BooleanTransform>('boolean') declare studentNameChange: boolean;

  [Type] = 'student-import-validation' as const
}
